import { render, staticRenderFns } from "./SummaryMonth.vue?vue&type=template&id=2db6453c&scoped=true&"
import script from "./SummaryMonth.vue?vue&type=script&lang=js&"
export * from "./SummaryMonth.vue?vue&type=script&lang=js&"
import style0 from "./SummaryMonth.vue?vue&type=style&index=0&id=2db6453c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db6453c",
  null
  
)

export default component.exports